import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72d18c25")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_tabs = _resolveComponent("header-tabs")
  const _component_messages_banner = _resolveComponent("messages-banner")
  const _component_orders_table = _resolveComponent("orders-table")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_header_tabs, { active: "current" }),
      _createVNode(_component_ion_content, { "scroll-y": true }, {
        default: _withId(() => [
          _createVNode(_component_messages_banner),
          (_ctx.shopOrders.curbsideOrders.length)
            ? (_openBlock(), _createBlock(_component_orders_table, {
                key: 0,
                title: "Curbside Orders",
                orders: _ctx.shopOrders.curbsideOrders
              }, null, 8, ["orders"]))
            : _createCommentVNode("", true),
          (_ctx.showPickup && _ctx.shopOrders.pickupOrders.length)
            ? (_openBlock(), _createBlock(_component_orders_table, {
                key: 1,
                title: "In Shop Orders",
                orders: _ctx.shopOrders.pickupOrders
              }, null, 8, ["orders"]))
            : _createCommentVNode("", true),
          (_ctx.shopOrders.oldOrders.length)
            ? (_openBlock(), _createBlock(_component_orders_table, {
                key: 2,
                title: "Completed Orders",
                orders: _ctx.shopOrders.oldOrders,
                class: "completed"
              }, null, 8, ["orders"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})